module.exports = __webpack_public_path__ + "img/console-tables.a7a1332.jpg";